/**
 * touch event helper
 * - touch event 座標を管理します
 * */

/**
 * x, y position を管理します
 */
export class Vectors {
  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }
  
  /**
   * 初期化します
   */
  reset() {
    this.x = 0;
    this.y = 0;
  }
  
  /**
   * 更新します
   * @param {number} x
   * @param {number} y
   */
  update(x, y) {
    this.x = x;
    this.y = y;
  }
  
  updateWithVectors({x, y}) {
    this.x = x;
    this.y = y;
  }
  
  distance(vectors) {
    const distanceX = this.x - vectors.x;
    const distanceY = this.y - vectors.y;
    const sqrt = (distanceX * distanceX) + (distanceY * distanceY);
    return Math.sqrt(sqrt);
  }
  
  /**
   * 引数 vectors との X 値を減算します
   * @param {Vectors} vectors 計測したい対象 Vectors instance
   * @returns {number} X 値を減算し返します
   */
  distanceX(vectors) {
    return this.x - vectors.x;
  }
  
  /**
   * 引数 vectors との Y 値を減算します
   * @param {Vectors} vectors 計測したい対象 Vectors instance
   * @returns {number} Y 値を減算し返します
   */
  distanceY(vectors) {
    return this.y - vectors.y;
  }
}

/**
 * touch event から x, y を取得します
 * @param {Event} event TouchEvent
 * @returns {Vectors} instance を返します
 */
export const eventWithPoint = (event) => {
  const x = event.pageX;
  const y = event.pageY;
  // event.pageX / pageY があればそのまま値を返します
  // Android で pageX / pageY 存在しても 0, 0 しか返さない端末あり
  const numX = parseFloat(x);
  const numY = parseFloat(y);
  if (!isNaN(numX) && !isNaN(numY) && (numX !== 0 && numY !== 0)) {
    return new Vectors(x, y);
  }
  // event.pageX / pageY がない時は TouchEvent の changedTouches から取得します
  // touch event
  // @type {TouchList}
  const touches = event.changedTouches || event.touches;
  // touches が取得できない時は 0 をセットし返します
  if (!touches || touches.length === 0) {
    return new Vectors(0, 0);
  }
  // changedTouches list の先頭データを取り出し pageX / pageY を取得します
  // @type {Touch}
  const touch = touches[0];
  return new Vectors(touch.pageX, touch.pageY);
};



// WEBPACK FOOTER //
// ./src/utils/touch-helper.js